import { Link } from 'react-router-dom';
import { Navbar,Container,Nav } from 'react-bootstrap';
import "./nav.css";

function Navbarr(){
    return(
        <div className='nav hh'>
            <Navbar bg="light" expand="lg">
                <Container>
                    <Navbar.Brand href="#home">Shop By Categories</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Link style={{backgroundImage: "url(../../images/menu-border.png)"}} to="home">Home</Link>
                        <Link style={{backgroundImage: "url(../../images/menu-border.png)"}} to="about">ABOUT US</Link>
                        <Link style={{backgroundImage: "url(../../images/menu-border.png)"}} to="delivery">DELIVERY</Link>
                        <Link style={{backgroundImage: "url(../../images/menu-border.png)"}} to="blog">BLOG</Link>
                        <Link style={{backgroundImage: "url(../../images/menu-border.png)"}} to="featured">FEATURED</Link>
                    </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
}

export default Navbarr;